export default {
  noProductFound: {
    id: 'models_comparison_no_product_found',
    defaultMessage: 'No product found',
  },
} as const
